export default "__VITE_ASSET__15747bbf__"